import { FC } from 'react';

interface Props {
  color?: string;
  className?: string;
}

const HatSvg: FC<Props> = ({ className }) => {
  return (
    <svg
      className={className}
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M6.83623 3.20214L1.73981 5.38632C1.59433 5.44867 1.5 5.59172 1.5 5.75C1.5 5.90828 1.59433 6.05133 1.73981 6.11368L6.83623 8.29786C7.14742 8.43123 7.48246 8.5 7.82103 8.5H8.17897C8.51754 8.5 8.85258 8.43123 9.16377 8.29786L14.2602 6.11368C14.4057 6.05133 14.5 5.90828 14.5 5.75C14.5 5.59172 14.4057 5.44867 14.2602 5.38632L9.16377 3.20214C8.85258 3.06877 8.51754 3 8.17897 3H7.82103C7.48246 3 7.14742 3.06877 6.83623 3.20214ZM1.5 7.64286L2.99994 8.28569V11.5139C2.99994 12.2714 3.42795 12.9639 4.10553 13.3027L4.91188 13.7059C6.85869 14.6793 9.1475 14.6917 11.1047 13.7394L12.0136 13.2973C12.7018 12.9624 13.1386 12.2642 13.1386 11.4988V8.22631L14.8511 7.4924C15.5481 7.19368 16 6.50832 16 5.75C16 4.99168 15.5481 4.30632 14.8511 4.0076L9.75465 1.82342C9.25674 1.61003 8.72068 1.5 8.17897 1.5H7.82103C7.27932 1.5 6.74326 1.61003 6.24535 1.82342L1.14893 4.0076C0.451923 4.30632 0 4.99168 0 5.75V10.25C0 10.6642 0.335787 11 0.75 11C1.16421 11 1.5 10.6642 1.5 10.25V7.64286ZM4.49994 11.5139V8.92855L6.24535 9.67658C6.74326 9.88997 7.27932 10 7.82103 10H8.17897C8.72068 10 9.25674 9.88997 9.75465 9.67658L11.6386 8.86917V11.4988C11.6386 11.6902 11.5294 11.8647 11.3573 11.9484L10.4485 12.3906C8.91068 13.1388 7.11233 13.129 5.58269 12.3642L4.77634 11.9611C4.60694 11.8764 4.49994 11.7032 4.49994 11.5139Z'
        fill='currentColor'
      />
    </svg>
  );
};

export default HatSvg;
